export default theme => ({
  actions: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: 40
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },

  // Copied from DataWizard
  messageList: {
    listStyle: 'none',
    margin: 0,
    padding: 0
  },
  violatedConstraints: {
    listStyle: 'none',
    margin: '10px 0 0 0',
    padding: 0
  },
  constraints: {
    padding: '0 0 10px 0',
    '&:last-child': {
      padding: 0
    }
  },
  loaderContainer: {
    height: '100%',
    maxHeight: '500px'
  },
  importContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    paddingBottom: 40
  }
});
